import PublicAuth from "./PublicAuth";
import Login from "../Views/Auth/Login";

export const PublicRoutes = () => {
  return [
    {
      element: <PublicAuth />,
      children: [
        {
          path: "/",
          element: <Login />,
        },
      
       
      ],
    },
  ];
};
